import React from 'react'
import cx from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import InputBase from '@material-ui/core/InputBase'
import { ResetIcon, OkIcon } from '../../app-icon/Icons'

const styles = theme => ({
  inputWrapper: {
    width: '100%',
    borderRadius: 4,
    position: 'relative',
    marginBottom: 16,
    border: 'solid 1px rgb(187, 187, 187)',
    backgroundColor: '#ffffff',
    transition: theme.transitions.create(['border']),
  },
  active: {
    border: 'solid 1px #9371ff',
  },
  dirty: {},
  asyncValidating: {},
  invalid: {
    border: 'solid 1px #ff4e44',
  },
  valid: {
    border: 'solid 1px #9371ff',
  },
  fieldError: {
    right: 0,
    color: '#0000009a',
    top: '50%',
    position: 'absolute',
    fontSize: 16,
    transform: 'translate(100%, -50%)',
    marginLeft: 20,
    fontFamily: 'Caveat',
    lineHeight: 'inherit',
    whiteSpace: 'pre-line',
    paddingLeft: 20,
    letterSpacing: 1.1,
    maxWidth: 280,
  },
  fieldError_normal: {
    top: 'inherit',
    right: 'inherit',
    color: '#ff4e44',
    position: 'absolute',
    fontSize: 12,
    transform: 'none',
    maxWidth: '100%',
    marginTop: 3,
    marginLeft: 0,
    fontFamily: '"Exo 2"',
    lineHeight: 'inherit',
    whiteSpace: 'nowrap',
    paddingLeft: 0,
    letterSpacing: 'inherit',
  },
  btnFieldClear: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '5px 12px',
    position: 'absolute',
    top: 0,
    right: 0,
    height: '100%',
    cursor: 'pointer',
    border: 0,
    backgroundColor: 'transparent',
    outline: 'none',
  },
  statusFieldOk: {
    width: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '5px 12px',
    position: 'absolute',
    top: 0,
    right: 0,
    height: '100%',
  },
  caption: {
    display: 'flex',
    alignItems: 'center',
    width: 'auto',
    position: 'absolute',
    top: 0,
    right: 0,
    padding: '0 19px 0 14px',
    height: '100%',
    fontSize: 16,
    fontWeight: 600,
    lineHeight: 2.5,
    color: 'rgba(0, 0, 0, 0.3)',
  },
})

const Input = withStyles(theme => ({
  input: {
    width: '100%',
    color: 'rgb(0, 0, 0)',
    fontSize: 16,
    borderRadius: 4,
    backgroundColor: '#ffffff',
    padding: '12px 40px 11px 20px',
  },
}))(InputBase)

const InputOutlined = props => {
  const {
    classes,
    input,
    type,
    meta,
    label,
    handleResetField,
    caption,
    focus,
    errorStyle,
  } = props

  return (
    <div
      className={cx(
        classes.inputWrapper,
        { [classes.dirty]: meta.dirty },
        { [classes.asyncValidating]: meta.asyncValidating },
        { [classes.active]: meta.active },
        { [classes.invalid]: meta.touched && meta.invalid },
        { [classes.valid]: meta.valid }
      )}
    >
      <Input
        {...input}
        placeholder={label}
        type={type}
        fullWidth
        autoFocus={focus}
      />

      {meta.error && meta.touched && !meta.active && (
        <div
          className={cx(classes.fieldError, {
            [classes.fieldError_normal]: errorStyle === 'normal',
          })}
        >
          {meta.error}
        </div>
      )}
      {input.value && meta.error && meta.touched && !meta.active && (
        <button
          className={classes.btnFieldClear}
          type="button"
          onClick={() => handleResetField(input.name)}
        >
          <ResetIcon width={16} height={16} stroke={'#ff2d55'} />
        </button>
      )}
      {caption && <div className={classes.caption}>{caption}</div>}
      {meta.valid && !caption && (
        <span className={classes.statusFieldOk}>
          <OkIcon width={16} height={16} stroke={'#8866ff'} />
        </span>
      )}
    </div>
  )
}

export default withStyles(styles)(InputOutlined)
